import { apiFetcher } from "./apiFetcher";

/**
 * Detects whether the current Wix Stores site uses Catalog V1 or V3.
 *
 * Wix is migrating sites to Catalog V3 (default for new sites). V1 and V3 are not
 * backwards-compatible, so every catalog read must resolve the version first.
 * `GET stores/v3/provision/version` works for both and returns
 * `V1_CATALOG` | `V3_CATALOG` | `STORES_NOT_INSTALLED`. The editor targets a single
 * store per session, so we memoize the resolved value. Defaults to `'V1'` on error.
 */
let cachedVersion = null;

function getCatalogVersion() {
  if (cachedVersion) {
    return Promise.resolve(cachedVersion);
  }

  return apiFetcher('stores/v3/provision/version', { method: 'GET' })
    .then((response) => {
      cachedVersion = response?.catalogVersion === 'V3_CATALOG' ? 'V3' : 'V1';
      return cachedVersion;
    })
    .catch(() => 'V1');
}

export const versioningWixService = {
  getCatalogVersion,
};
